import ShButton from "@/components/Helpers/ShButton";

// @vue/component
export default {
  name: "CampaignRecordsSearchPanel",

  components: {
    ShButton
  },

  props: {
    projectsList: {
      type: Array,
      default: () => []
    },
    dictionary: {
      type: Object,
      default: () => ({})
    }
  },

  data() {
    return {
      searchParams: {
        result: "",
        number: ""
      },
      isSearchPanelVisible: true,
      isEditDaysVisible: false
    };
  },

  created() {
    this.getIsSearchPanelValueFromLocalStorage();
  },

  computed: {
    statusList() {
      if (this.dictionary.status_dictionary) {
        return this.dictionary.status_dictionary.filter(
          item => item.stat === "ready" || item.stat === "pending"
        );
      }
    }
  },

  watch: {
    searchParams: {
      handler(newVal) {
        this.$emit("changeFilterBy", newVal);
      },
      deep: true
    }
  },

  methods: {
    clearSearchParams() {
      this.searchParams.number = "";
      this.searchParams.result = "";
    },
    toggleSearchBarVisibility() {
      this.isSearchPanelVisible = !this.isSearchPanelVisible;
      localStorage.setItem("isSearchPanelVisible", JSON.stringify(this.isSearchPanelVisible));
    },

    getIsSearchPanelValueFromLocalStorage() {
      const itemStr = localStorage.getItem("isSearchPanelVisible");
      if (!itemStr) {
        return null;
      }
      const item = JSON.parse(itemStr);
      this.isSearchPanelVisible = item;
    }
  }
};
